import { isBrowser } from './isBrowser';

const checkForGlobalProperty = (property: string, callback: () => void) => {
  if (!isBrowser()) return null;

  let attempts = 0;
  const maxAttempts = 200; // 10 seconds
  const interval = setInterval(() => {
    attempts++;
    if ((window as { [key: string]: any })[property] || attempts === maxAttempts) {
      callback();
      clearInterval(interval);
    }
  }, 50);
  return null;
};

export default checkForGlobalProperty;
